import React, { useRef, useEffect } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FloatLabel from "../../../UiComponents/FloatLabel/FloatLabel";
import { Formik, Form, Field } from "formik";
import {
  GetPolicyFileById,
  GetBookingCode,
  UpdatePolicyList,
} from "../../../Service/_index";
import CloseIcon from "@mui/icons-material/Close";
import { ToastError, ToastSuccess } from "../../../UiComponents/Toaster/Toast";
import moment from "moment";
import { Button, Tooltip, InputAdornment } from "@mui/material";
import { useState } from "react";
import {
  RemoveRedEyeIcon,
  DownloadIcon,
  CalculateIcon,
} from "../../../Resources/Icons/icons";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import * as Yup from "yup";
import Loader from "../../../UiComponents/Loader/Loader";

import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import Box from "@mui/material/Box";
import { Link, useNavigate } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Styles from "./CommisionPayable.module.scss";
import Dialog from "@mui/material/Dialog";

const CommonPayableDrawer = (props) => {
  const {
    selectedData,
    formType,
    setOpenDrawer,
    payableType,
    GetData,
    path,
    editType,
    UserPayablePercentage,
    BranchPayablePercentage,
    ReceivablePayablePercentage,
  } = props;
  let formRef = useRef();
  const initialValues = {
    policyNumber: "",
    companyName: "",
    bookingCode: "",
    subBookingCode: "",
    registrationNumber: "",
    product: "",
    subProduct: "",
    policyType: "",
    paCover: "",
    odPremium: "",
    tpPremium: "",
    netPremium: "",
    ODPercentage: "",
    ODAmount: "",
    TPPercentage: "",
    TPAmount: "",
    NETPercentage: "",
    NETAmount: "",
    fixedAmount: "",
    Total: "",
  };
  console.log("selected Data: ", selectedData);
  const [touchedVal, setTouchedVal] = useState(false);
  const [bookingCodeDetails, setBookingCodeDetails] = useState([]);
  const [allowDirectTotal, setAllowDirectTotal] = useState(null);
  const [bookingCodeValue, setBookingCodeValue] = useState(
    formType === "edit" ? selectedData?.bookingCodeId?.bookingCode : null,
  );
  const [openLoader, setOpenLoader] = useState(false);

  const GetBookingCodeDetails = () => {
    GetBookingCode({ isAscending: true }).then((res) => {
      const modifiedBookingCodeDetails = res?.data
        .map((e) => {
          if (e.isEnabled) {
            return {
              ...e,
              label: e.bookingCode,
              value: e._id,
            };
          } else {
            return null;
          }
        })
        .filter(Boolean);
      setBookingCodeDetails(modifiedBookingCodeDetails);
    });
  };
  const navigate = useNavigate();
  useEffect(() => {
    GetBookingCodeDetails();
    if (formType === "edit") {
      Object.keys(initialValues).forEach((el) => {
        initialValues[el] = selectedData[el];
      });
      if (payableType === "userPayable") {
        formRef.setFieldValue(
          "ODPercentage",
          selectedData?.userPayable?.ODPercentage || UserPayablePercentage?.OD,
        );
        formRef.setFieldValue(
          "TPPercentage",
          selectedData?.userPayable?.TPPercentage || UserPayablePercentage?.TP,
        );
        formRef.setFieldValue(
          "NETPercentage",
          selectedData?.userPayable?.NETPercentage ||
            UserPayablePercentage?.Net,
        );
        formRef.setFieldValue("ODAmount", selectedData?.userPayable?.ODAmount);
        formRef.setFieldValue("TPAmount", selectedData?.userPayable?.TPAmount);
        formRef.setFieldValue(
          "NETAmount",
          selectedData?.userPayable?.NETAmount,
        );
        formRef.setFieldValue(
          "fixedAmount",
          selectedData?.userPayable?.fixedAmount,
        );
        // the saved Total stays visible (it can differ from the parts, e.g. after a bulk upload)
        formRef.setFieldValue("Total", selectedData?.userPayable?.Total);
      } else if (payableType === "branchPayable") {
        formRef.setFieldValue(
          "ODPercentage",
          selectedData?.branchPayable?.ODPercentage ||
            BranchPayablePercentage?.OD,
        );
        formRef.setFieldValue(
          "TPPercentage",
          selectedData?.branchPayable?.TPPercentage ||
            BranchPayablePercentage?.TP,
        );
        formRef.setFieldValue(
          "NETPercentage",
          selectedData?.branchPayable?.NETPercentage ||
            BranchPayablePercentage?.Net,
        );
        formRef.setFieldValue(
          "ODAmount",
          selectedData?.branchPayable?.ODAmount,
        );
        formRef.setFieldValue(
          "TPAmount",
          selectedData?.branchPayable?.TPAmount,
        );
        formRef.setFieldValue(
          "NETAmount",
          selectedData?.branchPayable?.NETAmount,
        );
        formRef.setFieldValue(
          "fixedAmount",
          selectedData?.branchPayable?.fixedAmount,
        );
        // the saved Total stays visible (it can differ from the parts, e.g. after a bulk upload)
        formRef.setFieldValue("Total", selectedData?.branchPayable?.Total);
      } else {
        formRef.setFieldValue(
          "ODPercentage",
          selectedData?.commisionRecievable?.ODPercentage ||
            ReceivablePayablePercentage?.OD,
        );
        formRef.setFieldValue(
          "TPPercentage",
          selectedData?.commisionRecievable?.TPPercentage ||
            ReceivablePayablePercentage?.TP,
        );
        formRef.setFieldValue(
          "NETPercentage",
          selectedData?.commisionRecievable?.NETPercentage ||
            ReceivablePayablePercentage?.Net,
        );
        formRef.setFieldValue(
          "ODAmount",
          selectedData?.commisionRecievable?.ODAmount,
        );
        formRef.setFieldValue(
          "TPAmount",
          selectedData?.commisionRecievable?.TPAmount,
        );
        formRef.setFieldValue(
          "NETAmount",
          selectedData?.commisionRecievable?.NETAmount,
        );
        formRef.setFieldValue(
          "fixedAmount",
          selectedData?.commisionRecievable?.fixedAmount,
        );
        // the saved Total stays visible (it can differ from the parts, e.g. after a bulk upload)
        formRef.setFieldValue("Total", selectedData?.commisionRecievable?.Total);
      }
      formRef.setFieldValue(
        "companyName",
        selectedData?.companyId?.companyName,
      );
      formRef.setFieldValue("bookingCodeId", selectedData?.bookingCodeId?._id);
      formRef.setFieldValue("product", selectedData?.productId?.product);
      formRef.setFieldValue(
        "subProduct",
        selectedData?.subProductId?.subProduct,
      );
      formRef.setFieldValue(
        "subBookingCode",
        selectedData?.subBookingCodeId?.subBookingCode,
      );
      formRef.setFieldValue(
        "policyType",
        selectedData?.policyTypeId?.policyType,
      );
      formRef.setFieldValue(initialValues);
    } else {
    }
  }, []);

  const validationSchema = Yup.object().shape({
    Total: Yup.number()
      .min(0.1, "Total amount will be greater than zero")
      .required("Enter Total value")
      .typeError("Total must be a number"),
  });

  const CalaculteFunction = (e) => {
    if (allowDirectTotal) {
      setTouchedVal(true);
    } else {
      const ODAmountValue = (e?.odPremium * e.ODPercentage) / 100;
      const TPAmountValue = (e?.tpPremium * e.TPPercentage) / 100;
      const NETAmountValue = (e?.netPremium * e.NETPercentage) / 100;
      const FixedAmountValue = parseFloat(e?.fixedAmount);
      const TotalValue = (
        (ODAmountValue ? ODAmountValue : 0) +
        (TPAmountValue ? TPAmountValue : 0) +
        (NETAmountValue ? NETAmountValue : 0) +
        (FixedAmountValue ? FixedAmountValue : 0)
      ).toFixed(2);
      formRef.setFieldValue("ODAmount", ODAmountValue ? ODAmountValue : 0);
      formRef.setFieldValue("TPAmount", TPAmountValue ? TPAmountValue : 0);
      formRef.setFieldValue("NETAmount", NETAmountValue ? NETAmountValue : 0);
      formRef.setFieldValue("Total", TotalValue);
      setTouchedVal(true);
    }
  };

  const UserName = sessionStorage.getItem("UserId");

  // Money is compared / subtracted in whole paise: 12.10 - 2.20 in plain numbers is 9.899999999999999
  const toPaise = (value) => Math.round((Number(String(value ?? "").replace(/,/g, "")) || 0) * 100);

  const onSubmit = (e) => {
    const CurrentDate = new Date();
    let sendData = {};
    if (path === "commisionReceivable") {
      const receivedPaise = toPaise(selectedData?.commisionRecievable?.ReceivedAmount);
      const totalPaise = toPaise(e?.Total);
      if (editType === "Edit" && totalPaise < receivedPaise) {
        ToastError(
          `Total cannot be less than the amount already received (${(receivedPaise / 100).toFixed(2)})`
        );
        return;
      }
      sendData = {
        commisionRecievable: {
          ODPercentage: e?.ODPercentage,
          TPPercentage: e?.TPPercentage,
          NETPercentage: e?.NETPercentage,
          ODAmount: e?.ODAmount,
          TPAmount: e?.TPAmount,
          NETAmount: e?.NETAmount,
          fixedAmount: e?.fixedAmount,
          Total: e?.Total.replace(/,/g, ""),
          createdBy: selectedData.isCommisionRecievable
            ? selectedData?.commisionRecievable?.createdBy
            : UserName,
          createdAt: selectedData.isCommisionRecievable
            ? selectedData?.commisionRecievable?.createdAt
            : CurrentDate,
          updatedBy: selectedData.isCommisionRecievable ? UserName : "",
          updatedAt: selectedData.isCommisionRecievable
            ? CurrentDate
            : CurrentDate,
          ReceivedAmount: selectedData?.commisionRecievable?.ReceivedAmount,
          PendingAmount:
            editType === "Edit"
              ? ((totalPaise - receivedPaise) / 100).toFixed(2)
              : e?.Total.replace(/,/g, ""),
        },
        isCommisionRecievable: true,
        bookingCodeId: e?.bookingCodeId,
      };
    } else if (path === "userPayable") {
      sendData = {
        userPayable: {
          ODPercentage: e?.ODPercentage,
          TPPercentage: e?.TPPercentage,
          NETPercentage: e?.NETPercentage,
          ODAmount: e?.ODAmount,
          TPAmount: e?.TPAmount,
          NETAmount: e?.NETAmount,
          fixedAmount: e?.fixedAmount,
          Total: e?.Total.replace(/,/g, ""),
          PendingAmount: e.Total.replace(/,/g, ""),
          createdBy: selectedData.isUserPayable
            ? selectedData?.userPayable?.createdBy
            : UserName,
          createdAt: selectedData.isUserPayable
            ? selectedData?.userPayable?.createdAt
            : CurrentDate,
          updatedBy: selectedData.isUserPayable ? UserName : "",
          updatedAt: selectedData.isUserPayable ? CurrentDate : CurrentDate,
        },
        isUserPayable: true,
        bookingCodeId: e?.bookingCodeId,
        // by name, not by position: PolicyFilterTypes[4] is "rejectedPolicy" in this app
        status: "approvedPolicy",
        rejectedReason:
          selectedData.paymentMode === "Cheque" ? "Approved" : "Suspend",
      };
    } else {
      sendData = {
        branchPayable: {
          ODPercentage: e?.ODPercentage,
          TPPercentage: e?.TPPercentage,
          NETPercentage: e?.NETPercentage,
          ODAmount: e?.ODAmount,
          TPAmount: e?.TPAmount,
          NETAmount: e?.NETAmount,
          fixedAmount: e?.fixedAmount,
          Total: e?.Total.replace(/,/g, ""),
          createdBy: selectedData.isBranchPayable
            ? selectedData?.branchPayable?.createdBy
            : UserName,
          createdAt: selectedData.isBranchPayable
            ? selectedData?.branchPayable?.createdAt
            : CurrentDate,
          updatedBy: selectedData.isBranchPayable ? UserName : "",
          updatedAt: selectedData.isBranchPayable ? CurrentDate : CurrentDate,
          PendingAmount: e.Total,
        },
        isBranchPayable: true,
        bookingCodeId: e?.bookingCodeId,
      };
    }

    UpdatePolicyList(selectedData._id, sendData)
      .then((res) => {
        setOpenDrawer(false);
        GetData();
      })
      .catch((err) => {
        ToastError("Something wend wrong !");
      });
  };

  // const ViewPdfFunction = () => {

  //   const pdfUrl = selectedData?.policyFile?.downloadURL
  //   const pdfWindow = window.open("", "_blank");
  //   pdfWindow?.document?.write(
  //     `<embed src="data:application/pdf;base64,${pdfUrl}" width="100%" height="100%" />`
  //   );
  // };

  const ViewPdfFunction = () => {
    setOpenLoader(true);
    GetPolicyFileById(selectedData?._id)
      .then((res) => {
        console.log(res.data);
        const pdfUrl = res?.data?.policyFile?.downloadURL;
        return pdfUrl;
      })
      .then((pdfUrl) => {
        console.log("url", pdfUrl);
        const blobData = base64toBlob(pdfUrl, "application/pdf");
        const blobUrl = URL.createObjectURL(blobData);
        setOpenLoader(false);
        const pdfWindow = window.open("", "_blank");
        pdfWindow?.document?.write(
          // `<embed src="data:application/pdf;base64,${pdfUrl}" width="100%" height="100%" />`
          `<embed src="${blobUrl}" width="100%" height="100%" />`,
        );
      });
  };

  const base64toBlob = (base64Data, contentType) => {
    contentType = contentType || "";
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      var begin = sliceIndex * sliceSize;
      var end = Math.min(begin + sliceSize, bytesLength);

      var bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: contentType });
  };
  return (
    <>
      <div className={Styles.MainRenderinContainer}>
        <Stack direction={"row"} alignItems={"center"}>
          <div className="breadcrumb" style={{ marginLeft: "33px" }}>
            <a
              className="text-color"
              onClick={() => {
                navigate("/dashboard");
              }}
              style={{ cursor: "pointer" }}
            >
              {"Home"}
            </a>
            <span
              style={{
                padding: "0px 10px 0px 10px",
              }}
            >
              <ArrowForwardIosIcon
                style={{
                  fontSize: "13px",
                }}
              />
            </span>
            <a
              className="text-color"
              onClick={() => {
                setOpenDrawer(false);
              }}
              style={{ cursor: "pointer" }}
            >
              {"Utilites"}
            </a>
            <span
              style={{
                padding: "0px 10px 0px 10px",
              }}
            >
              <ArrowForwardIosIcon
                style={{
                  fontSize: "13px",
                }}
              />
            </span>
            <a className="text-color">{"View Utilites"}</a>
            <span
              style={{
                padding: "0px 10px 0px 10px",
              }}
            >
              <ArrowForwardIosIcon
                style={{
                  fontSize: "13px",
                }}
              />
            </span>
          </div>
        </Stack>
        {formType === "view" ? (
          <>
            <div className={Styles.formContainer}>
              <Grid
                container
                className="Master_Card_Container"
                sx={{ border: "none" }}
              >
                <Grid
                  container
                  alignItems={"center"}
                  className="Master_Card_Sub_Container"
                >
                  <Grid item xs={12} sm={6} md={6}>
                    <Typography className="Master_Card_Tittle">
                      {/* {source == "Profile" ? source : "Add User"} */}
                      {`View Policy`}
                    </Typography>
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={6}
                    className="d-flex justify-content-end"
                  >
                    <CloseIcon
                      onClick={() => setOpenDrawer(false)}
                      sx={{ cursor: "pointer" }}
                    />
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Divider
                    sx={{
                      backgroundColor: "#EAECF0",
                      borderWidth: 1,
                    }}
                  />
                </Grid>
              </Grid>
              <Box className={Styles.formContainer}>
                <Box
                  sx={{
                    borderBottom: "1px solid #EAECF0",
                    padding: "0 15px",
                    paddingBottom: "20px",
                  }}
                >
                  <Typography mt={3} className={Styles.formTitleHead}>
                    Policy Files
                  </Typography>
                  <Stack direction={"row"}>
                    <Grid container spacing={2} mt={1}>
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          New Policy
                        </Typography>
                        <Typography
                          className={Styles.inputValue}
                          onClick={() => ViewPdfFunction()}
                          sx={{ color: "blue", cursor: "pointer" }}
                        >
                          {selectedData?.policyNumber} .PolicyFile
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={0.7} />
                      <Grid item xs={12} sm={3.6}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          Documents
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.branchId?.branchName || "--"}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={0.7} />
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          User Name
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.userId?.name || "--"}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          Branch
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.userId?.name || "--"}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Stack>
                </Box>
                <Box
                  sx={{
                    borderBottom: "1px solid #EAECF0",
                    padding: "0 15px",
                    paddingBottom: "20px",
                  }}
                >
                  <Typography mt={3} className={Styles.formTitleHead}>
                    Personal Details
                  </Typography>
                  <Stack direction={"row"}>
                    <Grid container spacing={2} mt={1}>
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          Issue Date
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {moment(selectedData?.issueDate).format("DD/MM/YYYY")}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={0.7} />
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          Company Name
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.companyId?.companyName}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm={0.7} />
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          Product
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.productId?.product}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          Sub Product
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.subProductId?.subProduct}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm={0.7} />
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          Policy Type
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.policyTypeId?.policyType}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm={0.7} />
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          Booking Code
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.bookingCodeId?.bookingCode}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          Sub Booking Code
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.subBookingCodeId?.subBookingCode}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm={0.7} />
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          Policy Number
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.policyNumber}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm={0.7} />
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          Company Name
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.companyId?.companyName}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Stack>
                </Box>
                <Box
                  sx={{
                    borderBottom: "1px solid #EAECF0",
                    padding: "0 15px",
                    paddingBottom: "20px",
                  }}
                >
                  <Typography mt={3} className={Styles.formTitleHead}>
                    Customer Details
                  </Typography>
                  <Stack direction={"row"}>
                    <Grid container spacing={2} mt={1}>
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          Customer Name
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.customerName}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={0.7} />
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          Mobile
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.mobileNumber}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm={0.7} />
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          Email
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.email}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Stack>
                </Box>

                <Box
                  sx={{
                    borderBottom: "1px solid #EAECF0",
                    padding: "0 15px",
                    paddingBottom: "20px",
                  }}
                >
                  <Typography mt={3} className={Styles.formTitleHead}>
                    Vehicle Details
                  </Typography>
                  <Stack direction={"row"}>
                    <Grid container spacing={2} mt={1}>
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          Reg Number
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.registrationNumber}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={0.7} />
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          Make model
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.make?.vehicleMake}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm={0.7} />
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          CC
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.cc}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          Seating Capacity
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.seatingCapacity}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm={0.7} />
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          GVW
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.gvw}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Stack>
                </Box>

                <Box
                  sx={{
                    borderBottom: "1px solid #EAECF0",
                    padding: "0 15px",
                    paddingBottom: "20px",
                  }}
                >
                  <Typography mt={3} className={Styles.formTitleHead}>
                    OD Policy Date
                  </Typography>
                  <Stack direction={"row"}>
                    <Grid container spacing={2} mt={1}>
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          OD Policy Start Date
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {moment(selectedData?.odPolicyStartDate).format(
                            "DD/MM/YYYY",
                          )}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={0.7} />
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          OD Policy Period
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.odPolicyPeriod}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm={0.7} />
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          OD Policy End Date
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {moment(selectedData?.odPolicyEndDate).format(
                            "DD/MM/YYYY",
                          )}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Stack>
                </Box>

                <Box
                  sx={{
                    borderBottom: "1px solid #EAECF0",
                    padding: "0 15px",
                    paddingBottom: "20px",
                  }}
                >
                  <Typography mt={3} className={Styles.formTitleHead}>
                    TP Policy Date
                  </Typography>
                  <Stack direction={"row"}>
                    <Grid container spacing={2} mt={1}>
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          TP Policy Start Date
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {moment(selectedData?.tpPolicyStartDate).format(
                            "DD/MM/YYYY",
                          )}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={0.7} />
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          TP Policy Period
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.tpPolicyPeriod}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm={0.7} />
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          TP Policy End Date
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {moment(selectedData?.tpPolicyEndDate).format(
                            "DD/MM/YYYY",
                          )}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Stack>
                </Box>

                <Box
                  sx={{
                    borderBottom: "1px solid #EAECF0",
                    padding: "0 15px",
                    paddingBottom: "20px",
                  }}
                >
                  <Typography mt={3} className={Styles.formTitleHead}>
                    Premium
                  </Typography>
                  <Stack direction={"row"}>
                    <Grid container spacing={2} mt={1}>
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          OD Disc
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.odDisc}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={0.7} />
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          OD Premium
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.odPremium}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm={0.7} />
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          TP Premium
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.tpPremium}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          NET Premium
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.netPremium}
                        </Typography>
                      </Grid>

                      <Grid item xs={12} sm={0.7} />
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          Total Premium
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.totalPremium}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={0.7} />
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          PA Cover
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.paCover}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Stack>
                </Box>

                <Box
                  sx={{
                    borderBottom: "1px solid #EAECF0",
                    padding: "0 15px",
                    paddingBottom: "20px",
                  }}
                >
                  <Typography mt={3} className={Styles.formTitleHead}>
                    Payment Details
                  </Typography>
                  <Stack direction={"row"}>
                    <Grid container spacing={2} mt={1}>
                      <Grid item xs={12} sm={3.5}>
                        <Typography
                          className={Styles.inputTitle}
                          sx={{ fontSize: "12px", mb: 1 }}
                        >
                          Payment Mode
                        </Typography>
                        <Typography className={Styles.inputValue}>
                          {selectedData?.paymentMode}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Stack>
                </Box>
                {/* <Box>
                  <Button
                    onClick={() => setOpenDrawer(false)}
                    style={{
                      backgroundColor: "blue",
                      color: "white",
                      border: "none",
                      padding: "6px 40px",
                    }}
                  >
                    Close
                  </Button>
                </Box> */}
              </Box>
            </div>
          </>
        ) : (
          <>
            <div className={Styles.formContainer}>
              <Grid
                container
                className="Master_Card_Container"
                sx={{ border: "none" }}
              >
                <Grid
                  container
                  alignItems={"center"}
                  className="Master_Card_Sub_Container"
                  spacing={2}
                >
                  <Grid item xs={12} sm={6} md={6}>
                    <Typography className="Master_Card_Tittle">
                      {/* {source == "Profile" ? source : "Add User"} */}
                      {"View Policy Documents"}
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={6}
                    className="d-flex justify-content-end"
                  >
                    <CloseIcon
                      onClick={() => setOpenDrawer(false)}
                      sx={{ cursor: "pointer" }}
                    />
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  <Divider
                    sx={{
                      backgroundColor: "#EAECF0",
                      borderWidth: 1,
                    }}
                  />
                </Grid>
              </Grid>
              <Formik
                initialValues={initialValues}
                innerRef={(ref) => {
                  if (ref) {
                    formRef = ref;
                  }
                }}
                validationSchema={validationSchema}
                onSubmit={(values) => onSubmit(values)}
              >
                {({ values, setFieldValue, errors, touched }) => (
                  <Form>
                    {
                      <Box
                        sx={{
                          borderBottom: "1px solid #EAECF0",
                          padding: "0 15px",
                        }}
                      >
                        <Grid
                          container
                          columnSpacing={2}
                          rowSpacing={4}
                          mt={1} // Style added by Arun
                          style={{
                            display: "flex",
                          }}
                        >
                          <Grid item xs={12} sm={6} md={6}>
                            <Box>
                              <div>
                                <Field name="policyNumber">
                                  {({ field }) => (
                                    <FloatLabel
                                      label="Policy Number"
                                      value={values?.policyNumber}
                                    >
                                      <TextField
                                        {...field}
                                        fullWidth
                                        variant="outlined"
                                        className="textField w-100"
                                        InputProps={{
                                          readOnly: true,
                                          endAdornment: (
                                            <InputAdornment position="end">
                                              <Tooltip title="View">
                                                <RemoveRedEyeIcon
                                                  sx={{
                                                    color: "gray",
                                                    cursor: "pointer",
                                                  }}
                                                  onClick={ViewPdfFunction}
                                                />
                                              </Tooltip>
                                            </InputAdornment>
                                          ),
                                        }}
                                      />
                                    </FloatLabel>
                                  )}
                                </Field>
                              </div>
                            </Box>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6}>
                            <Box>
                              <FloatLabel
                                label="Company Name"
                                value={values?.companyName}
                              >
                                <Field
                                  name="companyName"
                                  className="textField w-100"
                                  value={values?.companyName}
                                  component={TextField}
                                  InputProps={{
                                    readOnly: true,
                                  }}
                                />
                              </FloatLabel>
                            </Box>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6}>
                            <Box>
                              <FloatLabel
                                label="Booking Code"
                                value={bookingCodeValue}
                              >
                                <Autocomplete
                                  className="AutoComplete_InputBox w-100"
                                  name="bookingCodeId"
                                  options={bookingCodeDetails}
                                  value={bookingCodeValue}
                                  onInputChange={(e, v) =>
                                    setBookingCodeValue(v)
                                  }
                                  onChange={(e, v) => {
                                    setFieldValue("bookingCodeId", v?._id);
                                    setBookingCodeValue(v?.label);
                                  }}
                                  renderInput={(params) => (
                                    <TextField {...params} />
                                  )}
                                  isOptionEqualToValue={(option, value) =>
                                    option.bookingCode === value
                                  }
                                />
                              </FloatLabel>
                            </Box>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6}>
                            <Box>
                              <FloatLabel
                                label="Sub Booking Code"
                                value={values?.subBookingCode}
                              >
                                <Field
                                  name="subBookingCode"
                                  className="textField w-100"
                                  value={values?.subBookingCode}
                                  component={TextField}
                                  InputProps={{
                                    readOnly: true,
                                  }}
                                />
                              </FloatLabel>
                            </Box>
                          </Grid>
                          <Grid item xs={12} sm={6} md={6}>
                            <Box>
                              <FloatLabel
                                label="Product"
                                value={values.product}
                              >
                                <Field
                                  name="product"
                                  className="textField w-100"
                                  value={values.product}
                                  component={TextField}
                                  InputProps={{
                                    readOnly: true,
                                  }}
                                />
                              </FloatLabel>
                            </Box>
                          </Grid>

                          <Grid item xs={12} sm={6} md={6}>
                            <Box>
                              <FloatLabel
                                label="Sub Product"
                                value={values.subProduct}
                              >
                                <Field
                                  name="subProduct"
                                  className="textField w-100"
                                  value={values.subProduct}
                                  component={TextField}
                                  InputProps={{
                                    readOnly: true,
                                  }}
                                />
                              </FloatLabel>
                            </Box>
                          </Grid>
                          <Grid item xs={12}>
                            <Divider
                              sx={{
                                backgroundColor: "#EAECF0",
                                borderWidth: 1,
                              }}
                            />
                          </Grid>

                          <Grid item xs={12} sm={6} md={4}>
                            <FloatLabel
                              label="Reg No"
                              value={values?.registrationNumber}
                            >
                              <Field
                                name="registrationNumber"
                                className="textField w-100"
                                value={values?.registrationNumber}
                                component={TextField}
                                InputProps={{
                                  readOnly: true,
                                }}
                              />
                            </FloatLabel>
                          </Grid>

                          <Grid item xs={12} sm={6} md={4}>
                            <FloatLabel
                              label="Policy Type"
                              value={values?.policyType}
                            >
                              <Field
                                name="policyType"
                                className="textField w-100"
                                value={values?.policyType}
                                component={TextField}
                                InputProps={{
                                  readOnly: true,
                                }}
                              />
                            </FloatLabel>
                          </Grid>

                          <Grid item xs={12} sm={6} md={4}>
                            <FloatLabel
                              label="PA Cover"
                              value={values?.paCover}
                            >
                              <Field
                                name="paCover"
                                className="textField w-100"
                                value={values?.paCover}
                                component={TextField}
                                InputProps={{
                                  readOnly: true,
                                }}
                              />
                            </FloatLabel>
                          </Grid>

                          <Grid item xs={12} sm={6} md={4}>
                            <FloatLabel
                              label="OD Pre"
                              value={values?.odPremium}
                            >
                              <Field
                                name="odPremium"
                                className="textField w-100"
                                value={values?.odPremium}
                                component={TextField}
                                InputProps={{
                                  readOnly: true,
                                }}
                              />
                            </FloatLabel>
                          </Grid>

                          <Grid item xs={12} sm={6} md={4}>
                            <FloatLabel
                              label="OD Per(%)"
                              value={values?.ODPercentage}
                            >
                              <Field name="ODPercentage">
                                {({ field }) => (
                                  <TextField
                                    {...field}
                                    className="textField w-100"
                                    value={values?.ODPercentage}
                                    onChange={(e) => {
                                      setFieldValue(
                                        "ODPercentage",
                                        e.target.value,
                                      );
                                      setTouchedVal(false);
                                      setAllowDirectTotal(false);
                                    }}
                                  />
                                )}
                              </Field>
                            </FloatLabel>
                          </Grid>

                          <Grid item xs={12} sm={6} md={4}>
                            <FloatLabel
                              label="OD Amount"
                              value={values?.ODAmount}
                            >
                              <Field
                                name="ODAmount"
                                className="textField w-100"
                                value={values?.ODAmount}
                                component={TextField}
                                InputProps={{
                                  readOnly: true,
                                }}
                              />
                            </FloatLabel>
                          </Grid>

                          <Grid item xs={12} sm={6} md={4}>
                            <FloatLabel
                              label="TP Pre"
                              value={values?.tpPremium}
                            >
                              <Field
                                name="tpPremium"
                                className="textField w-100"
                                value={values?.tpPremium}
                                component={TextField}
                                InputProps={{
                                  readOnly: true,
                                }}
                              />
                            </FloatLabel>
                          </Grid>

                          <Grid item xs={12} sm={6} md={4}>
                            <FloatLabel
                              label="TP Per(%)"
                              value={values?.TPPercentage}
                            >
                              <Field name="TPPercentage">
                                {({ field }) => (
                                  <TextField
                                    {...field}
                                    className="textField w-100"
                                    value={values?.TPPercentage}
                                    onChange={(e) => {
                                      setFieldValue(
                                        "TPPercentage",
                                        e.target.value,
                                      );
                                      setTouchedVal(false);
                                      setAllowDirectTotal(false);
                                    }}
                                  />
                                )}
                              </Field>
                            </FloatLabel>
                          </Grid>

                          <Grid item xs={12} sm={6} md={4}>
                            <FloatLabel
                              label="PA Amount"
                              value={values?.TPAmount}
                            >
                              <Field
                                name="TPAmount"
                                className="textField w-100"
                                value={values?.TPAmount}
                                component={TextField}
                                InputProps={{
                                  readOnly: true,
                                }}
                              />
                            </FloatLabel>
                          </Grid>

                          <Grid item xs={12} sm={6} md={4}>
                            <FloatLabel
                              label="NET Pre"
                              value={values?.netPremium}
                            >
                              <Field
                                name="netPremium"
                                className="textField w-100"
                                value={values?.netPremium}
                                component={TextField}
                                InputProps={{
                                  readOnly: true,
                                }}
                              />
                            </FloatLabel>
                          </Grid>

                          <Grid item xs={12} sm={6} md={4}>
                            <FloatLabel
                              label="NET Per(%)"
                              value={values?.NETPercentage}
                            >
                              <Field name="NETPercentage">
                                {({ field }) => (
                                  <TextField
                                    {...field}
                                    className="textField w-100"
                                    value={values?.NETPercentage}
                                    onChange={(e) => {
                                      setFieldValue(
                                        "NETPercentage",
                                        e.target.value,
                                      );
                                      setTouchedVal(false);
                                      setAllowDirectTotal(false);
                                    }}
                                  />
                                )}
                              </Field>
                            </FloatLabel>
                          </Grid>

                          <Grid item xs={12} sm={6} md={4}>
                            <FloatLabel
                              label="NET Amount"
                              value={values?.NETAmount}
                            >
                              <Field
                                name="NETAmount"
                                className="textField w-100"
                                value={values?.NETAmount}
                                component={TextField}
                                InputProps={{
                                  readOnly: true,
                                }}
                              />
                            </FloatLabel>
                          </Grid>

                          <Grid item xs={12} sm={6} md={4}>
                            <FloatLabel
                              label="Fixed Amount"
                              value={values?.fixedAmount}
                            >
                              <Field name="fixedAmount">
                                {({ field }) => (
                                  <TextField
                                    {...field}
                                    className="textField w-100"
                                    value={values?.fixedAmount ?? ""}
                                    onChange={(e) => {
                                      setFieldValue(
                                        "fixedAmount",
                                        e.target.value,
                                      );
                                      setTouchedVal(false);
                                      setAllowDirectTotal(false);
                                    }}
                                  />
                                )}
                              </Field>
                            </FloatLabel>
                          </Grid>

                          <Grid item xs={12} sm={6} md={4}>
                            <FloatLabel label="Total" value={values?.Total}>
                              <Field name="Total">
                                {({ field }) => (
                                  <TextField
                                    {...field}
                                    className="textField w-100"
                                    value={values?.Total}
                                    onChange={(e) => {
                                      setFieldValue("Total", e.target.value);
                                      setTouchedVal(false);
                                      setAllowDirectTotal(true);
                                    }}
                                  />
                                )}
                              </Field>
                            </FloatLabel>

                            <div className="errorMessage">
                              {errors.Total && touched.Total ? (
                                <div>{errors.Total}</div>
                              ) : (
                                " "
                              )}
                            </div>
                          </Grid>
                          <Grid item xs={12} sm={12} md={12}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 2,
                              }}
                            >
                              {touchedVal ? (
                                <button
                                  type="submit"
                                  className="TabelButton"
                                  style={{
                                    border: "none",
                                    marginBottom: "10px",
                                  }}
                                >
                                  Approve
                                </button>
                              ) : (
                                <Button
                                  className="Common_Button"
                                  endIcon={<CalculateIcon />}
                                  onClick={() => CalaculteFunction(values)}
                                  sx={{ mb: 2 }}
                                >
                                  Calculate
                                </Button>
                              )}
                            </Box>
                          </Grid>

                          {/* <Grid
                            className="Dialog_Footer"
                            item
                            xs={12}
                            sm={12}
                            gap={1}
                            p={1}
                          >
                            {/* <button onClick={() => setOpenDrawer(false)}>
                              Cancel
                            </button> */}
                          {/* <button type="submit"  >
                        Approve
                      </button> */}
                          {/* </Grid> */}
                        </Grid>
                      </Box>
                    }
                  </Form>
                )}
              </Formik>
            </div>

            <Loader open={openLoader} />
          </>
        )}
      </div>
    </>
  );
};

export default CommonPayableDrawer;
